import { useContext } from 'react';

import { RouterContextState } from '../lib/types';
import { RouterContext } from '../context/RouterContext';

export function useRouter<T = {}>() {
	return useContext(RouterContext) as RouterContextState<T>;
}
